module.exports = "<div [class]=\"className\">\n  <span>{{ title }}</span>\n</div>";